import { render } from "./StatsFilterOnView.vue?vue&type=template&id=37031ce2&scoped=true"
import script from "./StatsFilterOnView.vue?vue&type=script&lang=ts"
export * from "./StatsFilterOnView.vue?vue&type=script&lang=ts"

import "./StatsFilterOnView.vue?vue&type=style&index=0&id=37031ce2&lang=scss&scoped=true"
import "./StatsFilterOnView.vue?vue&type=style&index=1&id=37031ce2&lang=scss"
script.render = render
script.__scopeId = "data-v-37031ce2"

export default script